import React, { ReactNode, FC, RefObject } from "react";

import classNames from "classnames";

import {
  StyledTableWrapper,
  StyledTable,
  StyledTableBody,
  StyledTableHead,
} from "./Styles";

export interface ITableWithChildren {
  /** Children prop can be ReactNode. */
  children: ReactNode;
  /** Classname prop for custom styling. */
  className?: string;
}

export interface ITableProps {
  /** Darker color on odd column. */
  striped?: boolean;
  /** CSS classes. */
  className?: string;
  /** CSS classes for wrapper */
  wrapperClassName?: string;
  /** Ref object for table. */
  innerRef?: RefObject<HTMLTableElement>;
}

export const Table: FC<ITableProps & ITableWithChildren> = ({
  children,
  className,
  wrapperClassName,
  striped = false,
  innerRef,
}) => {
  return (
    <StyledTableWrapper
      className={classNames("c-table__wrap", wrapperClassName)}
    >
      <StyledTable
        ref={innerRef}
        className={classNames("c-table", className)}
        $striped={striped}
      >
        {children}
      </StyledTable>
    </StyledTableWrapper>
  );
};

Table.displayName = "Table";

export const Thead: FC<
  ITableWithChildren & { headerVariant?: "primary" | "secondary" }
> = ({ children, className, headerVariant = "primary" }) => (
  <StyledTableHead
    $headerVariant={headerVariant}
    className={classNames("c-table__head", className)}
  >
    {children}
  </StyledTableHead>
);

Thead.displayName = "Thead";

export const Tbody: FC<ITableWithChildren> = ({ children, className }) => (
  <StyledTableBody className={classNames("c-table__body", className)}>
    {children}
  </StyledTableBody>
);

Tbody.displayName = "Tbody";
